import React from 'react'
import { AgTechFormContext } from '@agtech/core/forms/AgTechFormContext';
import { AgTechFormControlUpdate } from '@agtech/core/forms/AgTechFormControls';
import AgTechTitleDetailHeader from '@agtech/web/components/Headers/AgTechTitleDetailHeader';
import { PaymentType, PaymentTypes } from '@sales/data/invoicing/payments/InvoicePaymentData';
import { AgTechQueryBuilder } from '@agtech/core/data/queries/AgTechDataQueries';
import AgTechFormLookup from '@agtech/web/components/Forms/Controls/Lookups/AgTechFormLookup';

const InvoicePaymentTypeSelectionControl = <TFormEntity, >(props: {
    formContext: AgTechFormContext<TFormEntity, any>,
    getSelectedPaymentType: (entity: TFormEntity) => string,
    onPaymentTypeSelected: AgTechFormControlUpdate<TFormEntity, PaymentType | undefined>
}) => {
    const formContext = props.formContext;

    return (
        <AgTechFormLookup
            entityType={formContext.entity}
            control={{
                caption: 'Payment Type'
            }}
            selection={{
                selectionControlTitle: 'Payment Type',
                data: {
                    itemQuery: AgTechQueryBuilder.buildQueryResult({
                        data: PaymentTypes
                    }),
                    selectedItemId: props.getSelectedPaymentType(formContext.entity),
                    searchItems: (item, filter) => {
                        return (item.description).includes(filter);
                    }
                },
                items: {
                    itemText: e => e.description,
                    itemHeight: 60,
                    itemRendering: e => (
                        <AgTechTitleDetailHeader
                            title={e.description}
                            titleFontSize='font-size-small'
                            detailFontSize='font-size-very-small'
                            detailClasses='mt-1-half'
                        />
                    ),
                },
                behavior: {
                    onItemSelected: props.onPaymentTypeSelected
                },
                popup: {
                    height: 240,
                    width: 360
                }
            }} 
        />
    )
}

export default InvoicePaymentTypeSelectionControl